const dashboardAuth = async (token: string, dev?: boolean, floorExternalId?: string) => {
  try {
    // eslint-disable-next-line no-undef
    const requestHeaders: HeadersInit = new Headers();
    requestHeaders.set('Content-Type', 'application/json');
    requestHeaders.set('Digital-Signage-Token', token);

    const baseEndpoint = dev ? 'https://api-v2-dev2.hereworks.tech' : 'https://api-v2.hereworks.tech';
    let url = `${baseEndpoint}/metrics/digital-signage-data`;
    if (floorExternalId) {
      url += `?floorExternalId=${floorExternalId}`;
    }
    const response = await fetch(
      url,
      {
        method: 'GET',
        headers: requestHeaders,
      },
    );
    const json = await response.json();
    return json;
  } catch (error) {
    // console.error(error);
    return null;
  }
};

export default dashboardAuth;
